
// Getter Object for TracksCatalog. Use it by calling mapGetters from the Vuex Host Components.

export const tracksCatalogGetters = {
  tracksCatalogData: (state) => state.tracksCatalogData,
  trackList: (state) => state.trackList,
  trackDetails: (state) => state.trackDetails,
  track_list_start_from: (state) => state.track_list_start_from,

  searchConfig: (state) => state.searchConfig,
}


